/*
 * Whether the page is browsing an old revision (plans/delete-rename-files.md).
 * Browsed runs must record nothing server-side, so the submission-posting
 * evaluators (server-evaluator, witnessed-js-evaluator) fold `browse: true`
 * into their bodies while this is set; index.ts flips it as browse mode is
 * entered and left. Module-level state is fine here: an assignment page has
 * exactly one editor and one browse state.
 */

let browsing = false;

export const setBrowsing = (b: boolean) => {
  browsing = b;
};

export const isBrowsing = () => browsing;
